export default __webpack_public_path__ + "static/media/GHSI Nomination and Election Policy.4ba769a5.pdf";